import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'
const api = {
  CreateMenuGroupLimit(payload) {
    return requestPost(apiPath.MENU_GROUP_LIMIT.path, payload)
  },

  GetOneMenuGroupLimit(menuGroupLimitID) {
    return requestGet(`${apiPath.MENU_GROUP_LIMIT.path}/${menuGroupLimitID}`)
  },

  GetAllMenuGroupLimit(paging, sorting, filtering) {
    return requestGet(apiPath.MENU_GROUP_LIMIT.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_menuGroupCode: filtering.menuGroupCode,
      f_orderType: filtering.orderType
    })
  },

  UpdateMenuGroupLimit(menuGroupLimitID, payload) {
    return requestPut(
      `${apiPath.MENU_GROUP_LIMIT.path}/${menuGroupLimitID}`,
      payload
    )
  },

  DeleteMenuGroupLimit(menuGroupLimitID) {
    return requestDelete(`${apiPath.MENU_GROUP_LIMIT.path}/${menuGroupLimitID}`)
  }
}

export default api
